import { BillRawV3, BillStatus } from '@types'
import { MockFactory } from '@tino-frontend/mocks'

export const billBaseMock = new MockFactory<BillRawV3>({
  closing_date: '2022-01-05T00:00:00Z',
  deliquency_fine_rate: 31001,
  due_amount: 31002,
  due_date: '2022-01-01T00:00:00Z',
  effective_due_date: '2023-03-08T00:00:00Z',
  flags: {
    has_debit: false,
    is_empty: false,
    is_zero: false,
    show_amounts_header: false,
  },
  id: 'bill-OPEN',
  line_item_groups: [],
  minimum_amount: 200,
  paid_amount: 31003,
  payable: false,
  spent_amount: 31004,
  status: BillStatus.Open,
})
